import {
  SWITCH_VIEW,
  OPEN_NEW_FLOW_DIALOG,
  CLOSE_NEW_FLOW_DIALOG,
  SET_OWNED_SHARED_FLOWS,
  SET_IS_LOADING_PORTAL_FLOWS,
  SET_WORKFLOW_ACTIVITIES,
  SET_ANALYTICS_ACTIVITIES,
  ADD_PORTAL_FLOW,
  ARE_FLOWS_LOADED,
  SET_PORTAL_USER_FLOWS,
  UPSERT_PORTAL_USER_FLOWS,
  REMOVE_PORTAL_USER_FLOWS,
  SET_PORTAL_FLOWS,
  OPEN_SHARER_FLOW_DIALOG,
  CLOSE_SHARER_FLOW_DIALOG,
  OPEN_SHAREE_FLOW_DIALOG,
  CLOSE_SHAREE_FLOW_DIALOG,
  SET_CREDENTIALS_IN_SHARED_FLOW,
  UPDATE_PORTAL_FLOW
} from "redux/constants/portal";

const initialState = {
  flowView: 1,
  showNewFlowDialog: false,
  flows: [],
  userFlows: [],
  ownedSharedFlows: [],
  areFlowsLoaded: false,
  isLoadingPortalFlows: false,
  workflowActivities: null,
  analyticsActivities: null,
  showSharerFlowDialog: false,
  showShareeFlowDialog: false,
  credentialsInSharedFlow: []
};

const view = (state = initialState, { type, payload }) => {
  switch (type) {
    case SWITCH_VIEW:
      return {
        ...state,
        flowView: payload
      };
    case OPEN_NEW_FLOW_DIALOG:
      return {
        ...state,
        showNewFlowDialog: true
      };
    case CLOSE_NEW_FLOW_DIALOG:
      return {
        ...state,
        showNewFlowDialog: false
      };
    case SET_PORTAL_FLOWS:
      return {
        ...state,
        flows: payload
      };
    case SET_IS_LOADING_PORTAL_FLOWS:
      return {
        ...state,
        isLoadingPortalFlows: payload
      };
    case SET_OWNED_SHARED_FLOWS:
      return {
        ...state,
        ownedSharedFlows: payload
      };
    case SET_WORKFLOW_ACTIVITIES:
      return {
        ...state,
        workflowActivities: payload
      };
    case SET_ANALYTICS_ACTIVITIES:
      return {
        ...state,
        analyticsActivities: payload
      };
    case SET_PORTAL_USER_FLOWS:
      return {
        ...state,
        userFlows: payload
      };
    case UPSERT_PORTAL_USER_FLOWS:
      return {
        ...state,
        userFlows: [
          ...new Map(
            [...state.userFlows, ...(payload ?? [])].map((userFlow) => [userFlow.id, userFlow])
          ).values()
        ]
      };
    case REMOVE_PORTAL_USER_FLOWS: {
      const userFlowIds = new Set(payload ?? []);
      return {
        ...state,
        userFlows: state.userFlows.filter(({ id }) => !userFlowIds.has(id))
      };
    }
    case ADD_PORTAL_FLOW:
      return {
        ...state,
        flows: state.flows.concat(payload)
      };
    case ARE_FLOWS_LOADED:
      return {
        ...state,
        areFlowsLoaded: true
      };
    case OPEN_SHARER_FLOW_DIALOG:
      return {
        ...state,
        showSharerFlowDialog: true
      };
    case CLOSE_SHARER_FLOW_DIALOG:
      return {
        ...state,
        showSharerFlowDialog: false,
        credentialsInSharedFlow: []
      };
    case OPEN_SHAREE_FLOW_DIALOG:
      return {
        ...state,
        showShareeFlowDialog: true
      };
    case CLOSE_SHAREE_FLOW_DIALOG:
      return {
        ...state,
        showShareeFlowDialog: false,
        credentialsInSharedFlow: []
      };
    case SET_CREDENTIALS_IN_SHARED_FLOW:
      return {
        ...state,
        credentialsInSharedFlow: payload
      };
    case UPDATE_PORTAL_FLOW:
      return {
        ...state,
        flows: state.flows.map((flow) =>
          flow.id === payload.id
            ? {
                ...flow,
                ...payload
              }
            : flow
        )
      };
  }
  return state;
};

export default view;
